import { EventEmitter as Emitter } from "eventemitter3";
export class CacheUpdateEvent {
    constructor(id, isNew) {
        this.id = id;
        this.isNew = isNew;
    }
}
CacheUpdateEvent.type = "CacheUpdate";
export class CacheDeleteEvent {
    constructor(id) {
        this.id = id;
    }
}
CacheDeleteEvent.type = "CacheUpdate";
export class CacheClearEvent {
}
CacheClearEvent.type = "CacheDelete";
export class AccountsEmitter {
    constructor() {
        this.emitter = new Emitter();
    }
    onCache(callback) {
        this.emitter.on(CacheUpdateEvent.type, callback);
        return () => this.emitter.removeListener(CacheUpdateEvent.type, callback);
    }
    raiseCacheUpdated(id, isNew) {
        this.emitter.emit(CacheUpdateEvent.type, new CacheUpdateEvent(id, isNew));
    }
    raiseCacheDeleted(id) {
        this.emitter.emit(CacheDeleteEvent.type, new CacheDeleteEvent(id));
    }
    raiseCacheCleared() {
        this.emitter.emit(CacheClearEvent.type, new CacheClearEvent());
    }
}
//# sourceMappingURL=emitter.js.map